<script>
  import {
    radioCheck,
    isCalculate,
    totalPopulation,
    totalJobs,
    averageAge,
    averageCommute,
    averageWalk,
    averageDeprivation,
    serverURL,
    LoadingBarValue,
    topZonesStore,
    top10Count,
  } from "../../../store.js";
  import * as ss from "simple-statistics";
  import * as turf from "@turf/turf";
  import geojson2h3 from "geojson2h3";

  export let zones;
  export let walkTime;
  export let map;
  let topZones;
  $: topZones = $topZonesStore;
  function toggleText() {
    if ($isCalculate) {
      calcScheme();
    } else {
      resetScheme();
    }
  }
  function calcScheme() {
    if (topZones == 0) {
      alert(
        "Use the sliding scale to select how many areas to base the analysis on. The sliding scale ranges from the 5% to the 50%  most suitable areas"
      );
      return;
    }

    var data = map.getSource("box")._data.features;
    const values = data.map((obj) => obj.properties[$radioCheck]);
    values.sort((a, b) => a - b);
    var tz = 1 - topZones / 100;
    var top10 = ss.quantile(values, [0, tz, 1]);

    let sortedValues = values.sort((a, b) => a - b);
    sortedValues = downsampleIfNeeded(sortedValues);

    var jenks = ss.jenks(sortedValues, 4);

    var count = values.filter((value) => value >= top10[1]).length;

    $top10Count = count;
    map.removeLayer("box-layer");
    $topZonesStore = topZones;
    map.addLayer(
      {
        id: "box-layer",
        type: "fill",
        source: "box",
        paint: {
          "fill-opacity": [
            "case",
            [">=", ["get", $radioCheck], top10[1]],
            0.8,
            0.1,
          ],
          "fill-color": [
            "interpolate",
            ["linear"],
            ["get", $radioCheck],
            0,
            "#af0505",
            jenks[1],
            "orange",
            jenks[2],
            "yellow",
            jenks[3],
            "lightgreen",
            jenks[4],
            "green",
          ],
        },
      },
      "tunnel-path-trail"
    );

    if (map.getSource("clusterSource")) {
      map.removeLayer("clusterLayer");
      map.removeSource("clusterSource");
    }
    if (data) {
      var top10Data = data.filter(
        (item) => item.properties[$radioCheck] >= top10[1]
      );

      var valresKey8 = top10Data.map((d) => {
        return d.properties.resKey8;
      });
      valresKey8 = [...new Set(valresKey8)];

      var val = geojson2h3
        .h3SetToFeatureCollection(valresKey8)
        .features.map((d) => {
          return turf.centroid(d).geometry.coordinates;
        });

      const pointFeatures = val.map((coord) => turf.point(coord));

      // Create a FeatureCollection from the array of Point features
      const featureCollection = turf.featureCollection(pointFeatures);

      // Define buffer distance (in kilometers, for example)
      const bufferDistance = zones;

      // Create a buffer around each point feature
      const bufferedFeatures = featureCollection.features.map((feature) => {
        return turf.buffer(feature, bufferDistance, { units: "kilometers" });
      });

      // Create a new FeatureCollection from the buffered features
      const bufferedFeatureCollection =
        turf.featureCollection(bufferedFeatures);

      var comb = turf.dissolve(bufferedFeatureCollection);
      // Output the buffered FeatureCollection

      map.addSource("isochroneSource", {
        type: "geojson",
        data: comb,
      });
      map.addLayer({
        id: "isochroneLayer", // Unique ID for the layer
        type: "fill", // Layer type (e.g., 'symbol', 'circle', 'fill', etc.)
        source: "isochroneSource", // Name of the GeoJSON source added earlier

        paint: {
          "fill-color": "#45bcbb",
          "fill-opacity": 0.2,
        },
      });

      /* var clustered = turf.clustersKmeans(featureCollection, {
        numberOfClusters: zones,
      });

      const clusterIds = [
        ...new Set(clustered.features.map((f) => f.properties.cluster)),
      ];

      var centroids = clusterIds.map((clusterId) => {
        const clusterPoints = turf.featureCollection(
          clustered.features.filter((f) => f.properties.cluster === clusterId)
        );
        const centroid = turf.centroid(clusterPoints);
        centroid.properties.cluster = clusterId; // Optionally, add cluster id to the centroid
        return centroid;
      });
      const centroidGeoJSON = turf.featureCollection(centroids);

      // Add the centroids as a source
      map.addSource("clusterSource", {
        type: "geojson",
        data: centroidGeoJSON,
      });

      map.addLayer({
        id: "clusterLayer", // Unique ID for the layer
        type: "circle", // Layer type (e.g., 'symbol', 'circle', 'fill', etc.)
        source: "clusterSource", // Name of the GeoJSON source added earlier

        paint: {
          "circle-radius": 10,
          "circle-opacity": 0,
          "circle-stroke-opacity": 0,
          "circle-color": "red",
          "circle-stroke-color": "white",
          "circle-stroke-width": 2,
        },
      });*/
    }
    var h3Calc = geojson2h3.featureToH3Set(comb, 10, {
      options: { ensureOutput: true },
    });

    var h3Search = geojson2h3.featureToH3Set(comb, 7, {
      options: { ensureOutput: true },
    });
    $LoadingBarValue = 1;
    setTimeout(() => {
      $LoadingBarValue = 10;
      fetch(`${$serverURL}api/data/schemeinfo?h3=${h3Search}`)
        .then((response) => response.json())
        .then((responseData) => {
          $LoadingBarValue = 50;

          const h3_polyfill_res10 = responseData.filter((item) =>
            h3Calc.includes(item.h3_polyfill)
          );

          // Simulate a delay to show progress
          setTimeout(() => {
            $LoadingBarValue = 80;

            const groupedData = h3_polyfill_res10.reduce(
              (accumulator, current) => {
                const key = current.h3_polyfill_res8;

                if (!accumulator[key]) {
                  accumulator[key] = {
                    h3_polyfill_res8: key,
                    totalPopulation: 0,
                    totalJobs: 0,
                  };
                }

                accumulator[key].totalPopulation += current.pop || 0;
                accumulator[key].totalJobs += current.jobs || 0;

                return accumulator;
              },
              {}
            );

            // Simulate a delay to show progress
            setTimeout(() => {
              $LoadingBarValue = 99;

              const groupedArray = Object.values(groupedData);

              // Simulate a delay to show progress
              setTimeout(() => {
                $totalPopulation = groupedArray.reduce(
                  (accumulator, current) => {
                    return accumulator + (current.totalPopulation || 0);
                  },
                  0
                );

                $totalJobs = groupedArray.reduce((accumulator, current) => {
                  return accumulator + (current.totalJobs || 0);
                }, 0);

                // Simulate a delay to show progress
                setTimeout(() => {
                  console.log("jobs and pop complete");
                  $LoadingBarValue = 100;
                  dataSpeedDials("age_15_45", h3_polyfill_res10);
                  dataSpeedDials("lessthan10km", h3_polyfill_res10);
                  dataSpeedDials("bikewalktowork", h3_polyfill_res10);
                  dataSpeedDialsDep("deprived", h3_polyfill_res10);

                  // Final progress update
                }, 200);
              }, 200);
            }, 200);
          }, 200);
        });
    }, 200);

    $isCalculate = false;
  }

  function systematicSample(data, interval) {
    return data.filter((_, index) => index % interval === 0);
  }

  function downsampleIfNeeded(data, threshold = 5000) {
    if (data.length > threshold) {
      let sampleSize = 1000;
      const interval = Math.floor(data.length / sampleSize);
      return systematicSample(data, interval);
    }
    return data;
  }

  function getIsochrones(centroids) {
    if (centroids) {
      if (map.getSource("isochroneSource")) {
        map.removeLayer("isochroneLayer");
        map.removeSource("isochroneSource");
      }

      var coords = centroids.map((feat) => feat.geometry.coordinates);

      const chunks = chunkArray(coords, 5);

      fetchAndCombineFeatures(chunks).then((combinedFeatures) => {
        var fc = turf.featureCollection(combinedFeatures);
        var comb = turf.dissolve(fc);
        map.addSource("isochroneSource", {
          type: "geojson",
          data: comb,
        });

        map.addLayer({
          id: "isochroneLayer",
          source: "isochroneSource",
          type: "fill",
          paint: { "fill-color": "white", "fill-opacity": 0.3 },
        });
        map.removeLayer("clusterLayer");
        map.addLayer({
          id: "clusterLayer", // Unique ID for the layer
          type: "circle", // Layer type (e.g., 'symbol', 'circle', 'fill', etc.)
          source: "clusterSource", // Name of the GeoJSON source added earlier

          paint: {
            "circle-radius": 10,
            "circle-color": "red",
            "circle-opacity": 0,
            "circle-stroke-opacity": 0,
            "circle-stroke-color": "white",
            "circle-stroke-width": 2,
          },
        });
        var h3Calc = geojson2h3.featureToH3Set(comb, 10, {
          options: { ensureOutput: true },
        });

        var h3Search = geojson2h3.featureToH3Set(comb, 7, {
          options: { ensureOutput: true },
        });
        fetch(`${$serverURL}api/data/schemeinfo?h3=${h3Search}`)
          .then((response) => response.json())
          .then((responseData) => {
            const h3_polyfill_res10 = responseData.filter((item) =>
              h3Calc.includes(item.h3_polyfill)
            );
            $totalPopulation = h3_polyfill_res10.reduce(
              (accumulator, current) => {
                return accumulator + (current.pop || 0); // Ensure pop is a number, default to 0 if undefined
              },
              0
            );
            $totalJobs = h3_polyfill_res10.reduce((accumulator, current) => {
              return accumulator + (current.jobs || 0); // Ensure pop is a number, default to 0 if undefined
            }, 0);

            dataSpeedDials("age_15_45", h3_polyfill_res10);
            dataSpeedDials("lessthan10km", h3_polyfill_res10);
            dataSpeedDials("bikewalktowork", h3_polyfill_res10);
            dataSpeedDialsDep("deprived", h3_polyfill_res10);
          });
      });
    }
  }
  function chunkArray(array, chunkSize) {
    let results = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      results.push(array.slice(i, chunkSize + i));
    }
    return results;
  }

  function makeApiRequest(coordsChunk) {
    return new Promise((resolve, reject) => {
      let request = new XMLHttpRequest();

      request.open(
        "POST",
        "https://api.openrouteservice.org/v2/isochrones/foot-walking"
      );

      request.setRequestHeader(
        "Accept",
        "application/json, application/geo+json, application/gpx+xml, img/png; charset=utf-8"
      );
      request.setRequestHeader("Content-Type", "application/json");
      request.setRequestHeader(
        "Authorization",
        "5b3ce3597851110001cf6248cd2339cc5b584fdfb63421699634ae63"
      );

      const body = JSON.stringify({
        locations: coordsChunk,
        range: [walkTime * 60], // Assuming the input is in minutes, convert to seconds
        range_type: "time",
      });
      request.send(body);

      request.onreadystatechange = function () {
        if (this.readyState === 4) {
          console.log("Status:", this.status);
          console.log("Headers:", this.getAllResponseHeaders());
          if (this.status === 200) {
            var geojson = JSON.parse(this.responseText);
            resolve(geojson.features);
          } else {
            console.error("Error:", this.statusText);
            reject(new Error(`Request failed with status ${this.status}`));
          }
        }
      };
    });
  }
  async function fetchAndCombineFeatures(chunks) {
    // Initialize an empty array to store all features
    let combinedFeatures = [];

    // Loop through each chunk
    for (let i = 0; i < chunks.length; i++) {
      try {
        // Make the API request for the current chunk
        let features = await makeApiRequest(chunks[i]);

        // Combine the result with the combinedFeatures array
        combinedFeatures = combinedFeatures.concat(features);
      } catch (error) {
        error("Error fetching features for chunk", i, error);
      }
    }

    return combinedFeatures;
  }

  function resetScheme() {
    $LoadingBarValue = 0;
    if (map.getLayer("isochroneLayer")) {
      map.removeLayer("isochroneLayer");
      map.removeSource("isochroneSource");
    }

    const elements = document.getElementsByClassName("schemeResults");

    // Loop through each element and set its opacity to 0
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.opacity = 0;
    }
    $isCalculate = true;
    document
      .querySelectorAll(".triangle")
      .forEach((element) => element.remove());
    $averageCommute = 0;
    $averageAge = 0;
    $averageDeprivation = 0;
    $averageWalk = 0;
    setTimeout(() => {
      $totalPopulation = 0;
      $totalJobs = 0;
    }, 1000);
    setTimeout(() => {
      document.getElementById("insights").value = "SP";
    }, 1);
  }

  function dataSpeedDials(el, h3_polyfill_res10) {
    const tot = h3_polyfill_res10.reduce(
      (accumulator, current) => {
        const tot = current[el] || 0; // Ensure ptal is a number, default to 0 if undefined
        accumulator.sum += tot;
        accumulator.count += current[el] !== undefined ? 1 : 0;
        return accumulator;
      },
      { sum: 0, count: 0 }
    );

    var newTot = tot.count > 0 ? tot.sum : 0;

    const variableMapping = {
      bikewalktowork: averageWalk,
      age_15_45: averageAge,
      lessthan10km: averageCommute,
      deprived: averageDeprivation, // Fallback variable if el is not 'Walk'
    };

    const variableToSet = variableMapping[el] || variableMapping.default;

    variableToSet.set(newTot);
  }
  function dataSpeedDialsDep(el, h3_polyfill_res10) {
    const tot = h3_polyfill_res10.reduce(
      (accumulator, current) => {
        const tot = current[el] || 0; // Ensure ptal is a number, default to 0 if undefined
        accumulator.sum += tot;
        accumulator.count += current[el] !== undefined ? 1 : 0;
        return accumulator;
      },
      { sum: 0, count: 0 }
    );

    var newTot = tot.count > 0 ? tot.sum / tot.count : 0;

    const variableMapping = {
      bikewalktowork: averageWalk,
      age_15_45: averageAge,
      lessthan10km: averageCommute,
      deprived: averageDeprivation, // Fallback variable if el is not 'Walk'
    };

    const variableToSet = variableMapping[el] || variableMapping.default;

    variableToSet.set(newTot);
  }
</script>

<button class="calcScheme" id="calcScheme_LP" on:click={toggleText}>
  {$isCalculate ? "Calculate" : "Reset"}
</button>

<style>
  .calcScheme {
    position: absolute;
    font-size: 12px;
    bottom: 0px;
    right: 0px;
    margin: 10px;
    border-radius: 10px;
  }
</style>
